import type { JSX } from "react";

import { Button } from "@mantine/core";

import classes from "./QuickActionButton.module.css";

interface QuickActionButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    value: string;
    loading?: boolean;
}

export function QuickActionButton({ value, loading, ...rest }: QuickActionButtonProps): JSX.Element {
    return (
        <Button
            value={value}
            aria-label={value as string}
            className={classes.quickActionButton}
            data-testid={`QuickAction-${value as string}`}
            loading={loading}
            {...rest}
        >
            {value}
        </Button>
    );
}
